<template>
  <div
    class="trigger"
    @click="toggleExpand"
  >
    <div class="_left">
      {{ $t('alignedItemAdvancedOptions.trigger') }}
    </div>

    <div class="_right">
      <m-btn
        :icon="expanded ? 'up' : 'down'"
        fab
        xs
        :icon-color="$colors.grey.base"
        hide-border
      />
    </div>
  </div>
  <div
    v-if="expanded"
    class="_items"
  >
    <template
      v-for="option in advancedOptions"
      :key="option.title"
    >
      <m-tooltip>
        <settings-switch-item
          :title="option.title"
          :value="option.value"
          @click="option.action"
        />
        <template #title>
          {{ option.tooltip }}
        </template>
      </m-tooltip>
    </template>
  </div>
</template>

<script setup>
import SettingsSwitchItem from '@/components/SettingsSwitchItem.vue';
import useGoals from '@/composables/goal/goals';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const goalSvc = useGoals();

const props = defineProps({ goal: { type: Object, required: true } });

const expanded = ref(true);

const unboundedProgress = computed(() => {
  if (props.goal.unboundedProgress === undefined) {
    return false;
  }

  return props.goal.unboundedProgress;
});

// We want to inverse this, meaning we display the negation to the user.
// TODO: write a migration for disableSatusUpdate -> enableStatusUpdate
const disableStatusUpdate = computed(() => {
  if (props.goal.disableStatusUpdate === undefined) {
    return false;
  }

  return props.goal.disableStatusUpdate;
});

const updateUnboundedProgress = () => goalSvc.updateSingle({ uid: props.goal.uid, unboundedProgress: !unboundedProgress.value });
const updateDisableStatusUpdate = () => goalSvc.updateSingle({ uid: props.goal.uid, disableStatusUpdate: !disableStatusUpdate.value });

const { t } = useI18n();

const advancedOptions = computed(() => [
  {
    title: t('alignedItemAdvancedOptions.settings.unboundedProgress'),
    value: unboundedProgress.value,
    action: updateUnboundedProgress,
    tooltip: t('alignedItemAdvancedOptions.tooltips.unboundedProgress'),
  },
  {
    title: t('alignedItemAdvancedOptions.settings.disableStatusUpdate'),
    value: !disableStatusUpdate.value,
    action: updateDisableStatusUpdate,
    tooltip: t('alignedItemAdvancedOptions.tooltips.disableStatusUpdate'),
  },
  // TODO: implement
  /* {
  *   title: t('alignedItemAdvancedOptions.settings.aggregateAbsolute'),
  *   value: null,
  *   action: null,
  *   tooltip: t('alignedItemAdvancedOptions.tooltips.aggregateAbsolute'),
  * }, */
]);

const toggleExpand = () => {
  if (expanded.value) {
    expanded.value = false;
    return;
  }

  expanded.value = true;
};
</script>

<style scoped lang="scss" type="text/scss">
  .trigger {
    display: flex;
    align-items: center;
    width: 100%;
    padding: .4rem 0;
    color: $font-color-secondary;
    cursor: pointer;

    ._left {
      flex: 1 1 auto;
      max-width: calc(100% - 15rem);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    ._right {
      display: flex;
      flex: 0 0 13rem;
      align-items: center;
      justify-content: flex-end;
      margin-left: auto;
    }
  }

  ._items {
    margin-top: .4rem;
  }

</style>
